import React from "react"
import { UseSearchReturn } from "./use-search"

export type SearchContextValue = Omit<UseSearchReturn, "store">
export const SearchContext = React.createContext<SearchContextValue | null>(
  null,
)

export default function useSearchContext(
  defaultValue?: SearchContextValue,
): SearchContextValue {
  const value = React.use(SearchContext)

  if (value === null) {
    if (defaultValue) {
      return defaultValue
    }
    throw new Error("useSearchContext must be used within SearchProvider")
  }

  return value
}
